import {
    PORTAL_BRANCH_SIGN_UP_AU_URL,
    PORTAL_BRANCH_SIGN_UP_CA_URL,
    PORTAL_BRANCH_SIGN_UP_GB_URL,
    PORTAL_BRANCH_SIGN_UP_NZ_URL,
    PORTAL_BRANCH_SIGN_UP_US_URL,
    PORTAL_UI_AU_HOST,
    PORTAL_UI_GB_HOST,
    PORTAL_UI_US_HOST,
} from "@/shared/constants";

import { Locale } from "@/types/locale";

const getGbPortalLocalePath = (locale: Locale): string =>
    `${PORTAL_UI_GB_HOST}${PORTAL_UI_GB_HOST?.endsWith("/uk") ? "" : "/uk"}/${locale}`;

export const getPortalURL = (locale: Locale): string => {
    switch (locale) {
        case "en-GB":
            return getGbPortalLocalePath(locale);
        case "it-IT":
            return `${PORTAL_UI_GB_HOST}/it`;
        case "fr-FR":
            return `${PORTAL_UI_GB_HOST}/fr`;
        case "es-ES":
            return `${PORTAL_UI_GB_HOST}/es`;
        case "en-NZ":
        case "en-AU":
            return `${PORTAL_UI_AU_HOST}/${locale}`;
        case "en-US":
        default:
            return `${PORTAL_UI_US_HOST}/${locale}`;
    }
};

export const getBranchPortalURL = (locale: Locale): string => {
    switch (locale) {
        case "it-IT":
            return `${PORTAL_UI_GB_HOST}/it`;
        case "fr-FR":
            return `${PORTAL_UI_GB_HOST}/fr`;
        case "es-ES":
            return `${PORTAL_UI_GB_HOST}/es`;
        case "en-CA":
        case "fr-CA":
            return PORTAL_BRANCH_SIGN_UP_CA_URL;
        case "en-NZ":
            return PORTAL_BRANCH_SIGN_UP_NZ_URL;
        case "en-GB":
            return PORTAL_BRANCH_SIGN_UP_GB_URL;
        case "en-AU":
            return PORTAL_BRANCH_SIGN_UP_AU_URL;
        case "en-US":
            return PORTAL_BRANCH_SIGN_UP_US_URL;
        default:
            return `${PORTAL_UI_US_HOST}/${locale}`;
    }
};
